import app from 'flarum/common/app';
app.initializers.add('redundans-email-notice-common', () => {
  console.log('[redundans/email-notice] Hello, forum and admin!');
});